$(function() {
  $('#calendar').daterangepicker({
    opens: 'left',
    allowInputToggle: true,
    "locale": {
      "daysOfWeek": [
          "Вс",
          "Пн",
          "Вт",
          "Ср",
          "Чт",
          "Пт",
          "Сб"
      ],
      "monthNames": [
          "Январь", 
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сентябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
      ],
        "format": 'DD.MM.YYYY'
    }
  }, function(start, end, label) {
    // console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
  });
});

$(init);
  function init() {
  $('.modal--calendar').append( $('.daterangepicker') );
}

$('.b-filter__item').click(function(event){
    $('#calendar').focus();
});



// WEBPACK FOOTER //
// ./src/js/pages/event-list/calendar.js